import {handleActions} from 'redux-actions'
const initialState = {
    Info: {},
    error: false,
}
const reducers = {}

reducers['OCR_FINISH'] = (state, action) => {
    return Object.assign({}, state, {Info: action.payload})
}
reducers['CLEAR_OCR_INFO'] = (state) => {
    return Object.assign({}, state, {Info: {}, error: false})
}
reducers['OCR_ERROR'] = (state) => {
    return Object.assign({}, state, {error: true})
}

export default handleActions(reducers, initialState)

